import { observer } from 'mobx-react';
import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../../../Translations';
import { Experience, learningJourneyExperience } from '../../../../../Experience/Types';

interface Props {
  experience: Experience;
}

function LearningJourneyPartners({ experience }: Props) {
  return learningJourneyExperience(experience)
    .map(({ schoolPartnerResources }) => (
      <Typography className="text-gray-900" variant="caption">
        <T kind="{{count}} School" count={schoolPartnerResources.length} />
      </Typography>
    ))
    .getOrElse(emptyFragment);
}

export default observer(LearningJourneyPartners);
